/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const deletedAccountSchema = z.object({
  createdAt: z.string().datetime().nullish(),
  deletedAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  integrationId: z.string().nullish(),
  salesforceId: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type DeletedAccount = z.infer<typeof deletedAccountSchema>;
